import "./appLoader.css";

const AppLoader = () => {
  return (
    <div className="cover">
        <div className="lds-ripple">
            <div></div>
            <div></div>
        </div>
    </div>
    
  );
};

export default AppLoader;
